export const FinancialInstrumentTypes = Object.freeze({
    UNLISTED_NCD: 'UnlistedNCD',
    INVOICE: "Invoice",
    LLP: 'LLP',
    COMMERCIAL_PAPER: "CommercialPaper",
    PTC: "PTC",
    G_SEC: "GSec",
    TREASURY_BILL: "TreasuryBill",
    MLD: "MLD"
});